import {AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild} from "@angular/core";
import {ActivatedRoute, Params, Router} from "@angular/router";
import {DatePipe, Location} from "@angular/common";
import {CardsService} from "../../services/cards.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NewsletterService} from "../../services/newsletter.service";
import {Newsletter} from "../../../dto/newsletter";
import {GrapesjsEditorComponent} from "../../../shared/grapesjs-editor/grapesjs-editor.component";
import {HtmlTemplateVar} from "../../../dto/templates/html-template-var";
import {OrderEmailTemplatesService} from "../../services/order-email-templates.service";
import {Company} from "../../../dto/company";
import {CompanyService} from "../../services/company.service";
import {CardStatus} from "../../../dto/cardStatus";
import {NewsletterDetail} from "../../../dto/newsletterDetail";
import {MatPaginator} from "@angular/material/paginator";
import {NewsletterSendTest} from "../../../dto/newsletter-send-test";
import {MatTableDataSource} from "@angular/material/table";
import {Product} from "../../../dto/product";
import {ProductService} from "../../services/product.service";
import {ReorderDelayReason} from "../../../dto/reorder-delay-reason";
import {NewsletterType} from "../../../dto/newsletter-type";
import {OrderSmsTemplatesService} from "../../services/order-sms-templates.service";
import {PushNotificationTemplatesService} from "../../../services/crud/push-notification-templates.service";
import {ToastService} from "angular-toastify";


@Component({
  selector: 'app-new-edit-sendmail',
  templateUrl: './new-edit-sendmail.component.html',
  styleUrls: ['./new-edit-sendmail.component.css']
})



export class NewEditSendMailComponent implements OnInit, AfterViewInit {

  smsCommandsLoaded = false;
  pushCommandsLoaded = false;



   constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private newsletterService: NewsletterService,
    private emailTemplatesService: OrderEmailTemplatesService,
    public companiesService: CompanyService,
    public productsService: ProductService,
    private smsTemplatesService: OrderSmsTemplatesService,
    private pushNotificationTemplatesService: PushNotificationTemplatesService,
    private _toaster: ToastService,
    private datePipe: DatePipe
  ) { }



  @ViewChild('iframeD', {static: false}) set iframe(iframe: ElementRef) {
    if (iframe) { // initially setter gets called with undefined
      if (!this.templateForm) {
        return;
      }
      if (this.templateForm.value.bodyHtml && !this.iframeIsSet) {
        this.iframeIsSet = true;
        this.iframeD = iframe;
        this.iframeD.nativeElement.contentWindow.frames.document.body.insertAdjacentHTML('beforebegin', this.templateForm.value.bodyHtml);
      }
    }
  }

  @ViewChild('textareamessage', { static:false }) smsMessageInput: ElementRef;

  @ViewChild('sharedgjs', {static: false}) set gEditor(gEditor: GrapesjsEditorComponent) {
    if (gEditor) { // initially setter gets called with undefined
      this.sharedgjs = gEditor;

      if (!this.editorIsInit) {
        this.go();
      }
      this.editorIsInit = true;
    }
  }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;


  testEmailForm: FormGroup;
  commands: HtmlTemplateVar[];
  smsCommands: HtmlTemplateVar[];
  pushCommands: HtmlTemplateVar[];
  public nlid: number = null;
  templateForm: FormGroup;
  public companies: Company[];
  public products: Product[];
  public otherNewsletters: { id: number; name: string; sendDate: Date }[];
  public cardStatuses: CardStatus[] = [
    {
      id: 0,
      name: 'Pending Activation'
    },
    {
      id: 18,
      name: 'Shipped'
    },
    {
      id: 1,
      name: 'Activated'
    },
    {
      id: 6,
      name: 'Closed'
    }
  ];
  public webIdStatis: any[] = [
    {
      id: 0,
      name: 'Pending'
    },
    {
      id: 1,
      name: 'Success'
    },
    {
      id: 2,
      name: 'Fail'
    }
  ];
  public orderLanguages: string[] = ['EN', 'DE'];
  details: NewsletterDetail[];
  newsletter: Newsletter = null;
  newsletterType = NewsletterType;

  trackOtherNewslettersByFn(index: number, item: any): number {
    return item.id; // or whatever uniquely identifies the item
  }

  prepareMailing() {

    this.isLoading = true;
    this.isPreparing = true;
    this.disableForm();
    this.newsletterService.update(this.templateForm.value).subscribe(result => {
      this.isLoading = false;
      this.newsletterService.prepareMailing(this.nlid).subscribe(
        async data => {
          this._toaster.info("Mailing is being prepared...");
          await this.startPolling();
        }, err => {
          this._toaster.error("Failed to prepare recipients");
          this.isPreparing = false;
          this.enableForm();
        }
      )
    });

    return false;
  }


  reorderDelayReason = ReorderDelayReason;

  isDetailsLoading = false;
  isLoading = false;
  isPreparing = false;
  isSaving = false;

  displayedColumns: string[] = ['email', 'firstName', 'lastName', 'mandrillStatusName', 'mandrillOpens', 'mandrillClicks', 'mandrillDiag'];
  dataSource = null;



  selectedCompanies = [];


  /* grapesjs */

  sharedgjs: GrapesjsEditorComponent;
  iframeD: ElementRef;

  editorIsInit = false;
  commandsLoaded = false;
  iframeIsSet = false;

  private loadNewsletterDataAsync(): Promise<Newsletter> {
    this.isLoading = true;

    return new Promise((resolve, reject) => {
      this.newsletterService.get(this.nlid).subscribe({
        next: (result) => {
          this.initForm(result, result.type);
          this.newsletter = result;

          if (
            result.isActive ||
            result.isSent ||
            result.isSending ||
            result.isPreparing
          ) {
            this.disableForm();
          }

          this.isLoading = false;

          if (result.isPrepared) {
            this.isDetailsLoading = true;
            this.getDetails(); // remains fire-and-forget
          }

          resolve(result);
        },
        error: (err) => {
          this.isLoading = false;
          reject(err);
        },
      });
    });
  }

  private getDetails() {
    this.newsletterService.getDetails(this.nlid).subscribe(result => {
      this.details = result;

      this.dataSource = new MatTableDataSource<NewsletterDetail>(this.details);
      this.dataSource.paginator = this.paginator;
      this.isDetailsLoading = false;

    });
  }

  ngOnInit() {


    this.isLoading = true;
    this.route.params.subscribe(async (params: Params) => {

      const nlIdStr = this.route.snapshot.paramMap.get('id');
      this.nlid = parseInt(nlIdStr);


      try {
        const [companiesResp, productsResp, newslettersResp] = await Promise.all([
          this.companiesService.getAll().toPromise(),
          this.productsService.getAll().toPromise(),
          this.newsletterService.getLast20().toPromise()
        ]);

        this.companies = companiesResp.data;
        this.products = productsResp.data;
        this.otherNewsletters = newslettersResp.data
          .filter((item: Newsletter) => item.id !== this.nlid)
          .map(item => ({
            id: item.id,
            name: item.name,
            sendDate: item.sendDate
          }));
      } catch (err) {
        this._toaster.error("Failed to load details: " + err.message);
        return;
      }




      try {
        // Await both requests in parallel
        const [emailResult, smsResult, pushResult] = await Promise.all([
          this.emailTemplatesService.getVarsNewsletter().toPromise(),
          this.smsTemplatesService.getVars().toPromise(),
          this.pushNotificationTemplatesService.getVars().toPromise()
        ]);

        // Store results
        this.commands = emailResult.data;
        this.smsCommands = smsResult.data;
        this.pushCommands = pushResult.data;

        this.commandsLoaded = true;
        this.smsCommandsLoaded = true;
        this.pushCommandsLoaded = true;

      } catch (err) {
        this._toaster.error('Failed to load SMS or push commands: ' + err.message);
        return;
      }

      let nl = null;
      if (!Number.isNaN(+this.nlid)) {

        try {
          this.newsletter = await this.newsletterService.get(this.nlid).toPromise();
        } catch (err) {
          this._toaster.error('Failed to load newsletter: ' + err.message);
          return;
        }

        this.testEmailForm = this.formBuilder.group({
          id: this.newsletter.id,
          email: '',
        });

        // Enable form if all conditions are met
        if (
          this.commandsLoaded &&
          this.smsCommandsLoaded &&
          this.pushCommandsLoaded &&
          this.newsletter &&
          !this.newsletter.isSending &&
          !this.newsletter.isSent
        ) {
          this.enableForm();
        }

        await this.startPolling();


      } else {

        if ( nlIdStr == "new") {
          const nl = new Newsletter();
          nl.type = NewsletterType.Email;
          nl.isActive = false;
          this.initForm(nl, nl.type);
          this.newsletter = nl;
          this.isLoading = false;
          this.enableForm();
          this.templateForm.get('isActive')?.disable();
        }
        else if ( nlIdStr == "new-sms") {
          const nl = new Newsletter();
          nl.type = NewsletterType.Sms;
          nl.isActive = false;
          this.initForm(nl, nl.type);
          this.disableForm();
          this.newsletter = nl;
          this.isLoading = false;
          if ( !nl.isActive && !nl.isSending && !nl.isPreparing ) {
            this.enableForm();
          }

        }
        else if ( nlIdStr == "new-push") {
          const nl = new Newsletter();
          nl.type = NewsletterType.Push;
          nl.isActive = false;
          this.initForm(nl, nl.type);
          this.newsletter = nl;
          this.isLoading = false;
          if ( !nl.isActive && !nl.isSending && !nl.isPreparing ) {
            this.enableForm();
          }

        }



        this.testEmailForm = this.formBuilder.group({
          id: null,
          email: '',
        });

      }



    });
  }

  private isPolling = false;

  private async startPolling() {
    console.log("Starting Polling...");
    this.isPolling = true;
    await this.pollLoop();
  }

  private async pollLoop() {
    if (!this.isPolling) return;

    try {
      const nl1 = await this.loadNewsletterDataAsync();

      if (nl1.isSent || (!nl1.isSending && !nl1.isPreparing)) {
        this.stopPolling();
        this.enableForm();

        if (this.isPreparing && !nl1.isPreparing) {
          this.isPreparing = false;
          this.getDetails();
        }
      }

      if (nl1.isSent || nl1.isActive) {
        this.disableForm();
      }
    } catch (err) {
      this._toaster.warn('Polling failed: ' + err.message);
    }

    if (this.isPolling) {
      setTimeout(() => this.pollLoop(), 2000);
    }
  }

  private stopPolling() {
    console.log("Stop Polling");
    this.isPolling = false;
  }

  lastFocusedElement: any;

  ngAfterViewInit(): void {
    /*const formElement = this.renderer.selectRootElement('.content-card', true);
    if (formElement) {
      formElement.addEventListener('focusin', (event: FocusEvent) => {
        const target = event.target as HTMLElement;
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          this.lastFocusedElement = target;
        }
      });
    }*/
  }

  onFocus(event: FocusEvent) {
    this.lastFocusedElement = event.target;
  }

  insert(text: string) {
    if (this.lastFocusedElement) {

      const text2 = '*|' + text + '|*';

      const input = this.lastFocusedElement as HTMLInputElement;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      const originalValue = input.value;
      input.value = originalValue.substring(0, start) + text2 + originalValue.substring(end);
      input.setSelectionRange(start + text2.length, start + text2.length); // Move the cursor after the inserted text
      input.focus();

      // Find the form control name based on the input element
      const controlName = input.getAttribute('formControlName');
      if (controlName) {
        const ctrl = this.templateForm.get(controlName);
        ctrl?.setValue(input.value);
        ctrl?.updateValueAndValidity();
      }

    }
  }

  onEmojiSelected(emoji: string) {
    if (this.lastFocusedElement) {

      const text2 = emoji;

      const input = this.lastFocusedElement as HTMLInputElement;
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || 0;
      const originalValue = input.value;
      input.value = originalValue.substring(0, start) + text2 + originalValue.substring(end);
      input.setSelectionRange(start + text2.length, start + text2.length); // Move the cursor after the inserted text
      input.focus();

      // Find the form control name based on the input element
      const controlName = input.getAttribute('formControlName');
      if (controlName) {
        const ctrl = this.templateForm.get(controlName);
        ctrl?.setValue(input.value);
        ctrl?.updateValueAndValidity();
      }

    }
  }


  initForm(item: Newsletter, type: NewsletterType) {

    let nl: Newsletter|null = null;

    if (item != null) {
      nl = item;
    } else {
      nl = new Newsletter();
      nl.isActive = false;
    }

    nl.type = type;


    this.templateForm = this.formBuilder.group({
      id: [nl.id],
      isActive: [nl.isActive],
      type: [nl.type],
      name: [nl.name, Validators.required], // required
      sendDate: [nl.sendDate, Validators.required], // required
      sendDateHh: [nl.sendDateHh, [Validators.required, Validators.min(0), Validators.max(23)]], // required
      sendDateMm: [nl.sendDateMm, [Validators.required, Validators.min(0), Validators.max(59)]], // required

      subject: [nl.subject, []],
      title: [nl.title, []],
      bodyHtml: [nl.bodyHtml, []],
      mjml: [nl.mjml, []],
      action: [nl.action, []],
      actionLabel: [nl.actionLabel, []],
      actionParameter: [nl.actionParameter, []],

      getFilterCompanyIdsAsList: [[], []],
      getFilterProductIdsAsList: [[], []],
      getFilterNotProductIdsAsList: [[], []],

      getFilterCustomerIdsAsList: [[], []],
      getFilterCardTypesAsList: [[], []],
      getFilterNotCardTypesAsList: [[], []],
      getFilterNotInNewsletterIdsAsList: [[], []],
      getFilterInNewsletterIdsAsList: [[], []],

      getFilterCardStatusIdsAsList: [[], []],
      getFilterCustomerIdentLevelsAsList: [[], []],
      //getFilterWebIdStatusIdsAsList: [[], []],

      filterCustomerIds: [nl.filterCustomerIds, []],

      filterCreateDateFrom: [nl.filterCreateDateFrom, []],
      filterCreateDateTo: [nl.filterCreateDateTo, []],
      filterSepa: [nl.filterSepa, []],
      filterAppDownload: [nl.filterAppDownload, []],
      filterSofort: [nl.filterSofort, []],
      filterBtl: [nl.filterBtl, []],
      filterAddressConfirmed: [nl.filterAddressConfirmed, []],
      filterReOrderPending: [nl.filterReOrderPending, []],
      filterReOrderDelayReason: [nl.filterReOrderDelayReason, []],
      filterOrderDateFrom: [nl.filterOrderDateFrom, []],
      filterOrderDateTo: [nl.filterOrderDateTo, []],
      filterOrderCreateDateFrom: [nl.filterOrderCreateDateFrom, []],
      filterOrderCreateDateTo: [nl.filterOrderCreateDateTo, []],
      filterOrderLanguagesAsList: [[], []],
      filterPlatformsAsList: [[], []]
    });


    this.templateForm.controls['getFilterCompanyIdsAsList'].setValue(nl.getFilterCompanyIdsAsList);
    this.templateForm.controls['getFilterProductIdsAsList'].setValue(nl.getFilterProductIdsAsList);
    this.templateForm.controls['getFilterNotProductIdsAsList'].setValue(nl.getFilterNotProductIdsAsList);
    this.templateForm.controls['getFilterCustomerIdsAsList'].setValue(nl.getFilterCustomerIdsAsList);
    this.templateForm.controls['getFilterCardTypesAsList'].setValue(nl.getFilterCardTypesAsList);
    this.templateForm.controls['getFilterNotCardTypesAsList'].setValue(nl.getFilterNotCardTypesAsList);
    this.templateForm.controls['getFilterNotInNewsletterIdsAsList'].setValue(nl.getFilterNotInNewsletterIdsAsList);
    this.templateForm.controls['getFilterInNewsletterIdsAsList'].setValue(nl.getFilterInNewsletterIdsAsList);
    this.templateForm.controls['getFilterCardStatusIdsAsList'].setValue(nl.getFilterCardStatusIdsAsList);
    this.templateForm.controls['getFilterCustomerIdentLevelsAsList'].setValue(nl.getFilterCustomerIdentLevelsAsList);
    //this.templateForm.controls['getFilterWebIdStatusIdsAsList'].setValue(nl.getFilterWebIdStatusIdsAsList);
    this.templateForm.controls['filterOrderLanguagesAsList'].setValue(nl.filterOrderLanguagesAsList);
    this.templateForm.controls['filterPlatformsAsList'].setValue(nl.filterPlatformsAsList);

  }

  save() {
    this.onSubmit(this.templateForm);
  }

  onSubmit(nlForm: FormGroup) {

    if (!nlForm.valid) {
      const invalidFields: string[] = [];

      Object.keys(nlForm.controls).forEach(field => {
        const control = nlForm.get(field);
        if (control && control.invalid) {
          invalidFields.push(field);
          control.markAsTouched(); // optional: shows errors in UI
        }
      });

      alert('Invalid fields:\n' + invalidFields.join('\n'));
      return;
    }

    this.isSaving = true;

    if (nlForm.value.sendDate == null) {
      alert('Senddate can not be empty.');
      return;
    }

    if ( this.newsletter.type == NewsletterType.Email ) {
      const mjml = this.sharedgjs.editorGJS.getHtml();
      const html = this.sharedgjs.editorGJS.runCommand('mjml-get-code').html;

      this.templateForm.value.bodyHtml = html;
      this.templateForm.value.mjml = mjml;
    } else if ( this.newsletter.type == NewsletterType.Push ) {

    } else {
      this.templateForm.value.bodyHtml = "";
      this.templateForm.value.mjml = "";
    }



    if ( Number.isNaN(this.nlid) ) {
      this.newsletterService.add(this.templateForm.value).subscribe(result => {

        this.disableForm();

        this.router.navigate(['/send-info/' + result.id])
          .then(() => {
            window.location.reload();
          });

        // this.router.navigate(["/send-info/"+result.id]);
        // this.router.navigate(["/send-info"]);

      });

    } else {
      this.isLoading = true;
      this.newsletterService.update(this.templateForm.value).subscribe(result => {
        this.isLoading = false;
        window.location.reload();
      });

    }




  }



  sendTest() {

    const model = new NewsletterSendTest();
    model.id = this.newsletter.id;
    model.email = this.testEmailForm.value.email;
    this.newsletterService.sendTest(model).subscribe(result => {
      alert('Test Email sent.');
    });
  }

  async go() {
    let shouldStop = false;
    while (!shouldStop) {

      if (this.editorIsInit && this.commandsLoaded) {
        shouldStop = true;
        this.sharedgjs.go();
      }
      await this.delay(500);
    }
  }

  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }

  saveFromEditor(data) {
    this.save();
  }

  protected readonly ReorderDelayReason = ReorderDelayReason;

  addText(placeholder: string){

    const domElement = this.smsMessageInput.nativeElement;
    const val = '*|' + placeholder + '|*';

    if (domElement.selectionStart || domElement.selectionStart === 0) {
      const startPos = domElement.selectionStart;
      const endPos = domElement.selectionEnd;
      const scrollTop = domElement.scrollTop;
      domElement.value = domElement.value.substring(0, startPos) + val + domElement.value.substring(endPos, domElement.value.length);
      domElement.focus();
      domElement.selectionStart = startPos + val.length;
      domElement.selectionEnd = startPos + val.length;
      domElement.scrollTop = scrollTop;
    } else {
      domElement.value += val;
      domElement.focus();
    }

    this.templateForm.controls['subject'].patchValue(domElement.value);


  }

  emergencyStop() {
    this.newsletterService.emergencyStop(this.newsletter.id).subscribe(result => {})
  }

  unapprove() {



    this.stopPolling();

    this.newsletterService.update(this.templateForm.value).subscribe(result => {
      this.isLoading = false;
      this.stopPolling();

      setTimeout(() => {
        this.newsletter.isActive = false;
        this.templateForm.controls['isActive'].patchValue(true);

        this.newsletterService.cancelApproval(this.newsletter.id).subscribe(result => {
          this.newsletter.isActive = false;

          this.enableForm();
        }, error => {window.location.reload()});
      }, 500);


    });

  }

  approve() {

    this.isLoading = true;
    this.templateForm.controls['isActive'].patchValue(true);
    this.newsletter.isActive = true;
    this.newsletterService.update(this.templateForm.value).subscribe(async result => {
      this.isLoading = false;
      await this.startPolling();
    }, error => {window.location.reload()});



  }

  disableForm() {
    this.templateForm?.disable();
  }
  enableForm() {
    this.templateForm?.enable();
  }

  protected readonly NewsletterType = NewsletterType;
  protected readonly isNaN = isNaN;

  getCompanyNames(ids: number[]): string[] {
    return this.companies
      .filter(c => ids.includes(c.id))
      .map(c => c.name);
  }

  getNewsletterNames(ids: number[]): string[] {
    return this.otherNewsletters
      .filter(nl => ids.includes(nl.id))
      .map(nl => `${this.datePipe.transform(nl.sendDate, 'yyyy-MM-dd HH:mm')} ${nl.name}`);
  }

  getProductNames(ids: number[]): string[] {
    return this.products
      .filter(p => ids.includes(p.id))
      .map(p => p.shortName + ' - ' + p.internalName);
  }

  getCardStatusNames(ids: number[]): string[] {
    return this.cardStatuses
      .filter(s => ids.includes(s.id))
      .map(s => s.name);
  }

  innerEllipsis(txt: string): string {
    if (txt.length > 40) {
      return txt.substring(0, 10) + "..." + txt.substring(txt.length - 10);
    }
    return txt;
  }



}
